import { AppIcon, LabeledInput, StatusBanner } from "../components/InstateamMasterComponents";

export default function AdminLoginPage({
  loginForm,
  isSubmittingLogin,
  showPassword,
  onChange,
  onSubmit,
  onTogglePassword,
  statusMessage,
  onForgotPassword,
}) {
  return (
    <div className="admin-auth-shell">
      <section className="admin-auth-card">
        <div className="admin-auth-visual-side">
         

          <div className="auth-hero-copy">
            <h1>
              Welcome Back,
              <br />
              <span>Admin!</span>
            </h1>
            <p>Securely access the admin panel to manage your organization and employees.</p>
          </div>

          <div className="auth-visual-note">
            <div className="auth-visual-note-icon">
              <AppIcon name="shieldLock" />
            </div>
            <div>
              <strong>Secure. Reliable. Efficient.</strong>
              <span>All in one HRMS Solution.</span>
            </div>
          </div>

          <div className="admin-office-scene" aria-hidden="true">
            <span className="admin-window-frame" />
            <span className="admin-city-skyline" />
            <span className="admin-office-desk" />
            <span className="admin-office-monitor" />
            <span className="admin-office-chair" />
            <span className="admin-office-lamp" />
            <span className="admin-office-plant" />
          </div>
        </div>

        <div className="admin-auth-form-side">
          <div className="login-panel-card">
            <div className="login-panel-icon">
              <AppIcon name="shieldLock" />
            </div>

            <div className="login-panel-heading">
              <h1>Admin Login</h1>
              <p>Sign in to access the admin panel</p>
            </div>

            {statusMessage ? (
              <StatusBanner type={statusMessage.type} text={statusMessage.text} onClose={null} />
            ) : null}

            <form className="auth-form" onSubmit={onSubmit}>
              <LabeledInput
                label="Admin ID / Email"
                value={loginForm.email}
                onChange={(value) =>
                  onChange((current) => ({ ...current, email: value }))
                }
                placeholder="Enter admin ID or email"
                icon="employees"
              />

              <LabeledInput
                label="Password"
                value={loginForm.password}
                onChange={(value) =>
                  onChange((current) => ({ ...current, password: value }))
                }
                placeholder="Enter your password"
                icon="lock"
                type={showPassword ? "text" : "password"}
                trailingButton={
                  <button className="field-icon-button" type="button" onClick={onTogglePassword}>
                    <AppIcon name={showPassword ? "eyeOff" : "eye"} />
                  </button>
                }
              />

              {/* <div className="auth-row">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={loginForm.rememberMe}
                    onChange={(event) =>
                      onChange((current) => ({
                        ...current,
                        rememberMe: event.target.checked,
                      }))
                    }
                  />
                  <span>Remember me</span>
                </label>

                <button className="link-button" type="button" onClick={onForgotPassword}>
                  Forgot Password?
                </button>
              </div> */}

              <button className="primary-button auth-submit-button" type="submit">
                <AppIcon name="lock" />
                {isSubmittingLogin ? "Signing In..." : "Login as Admin"}
              </button>
            </form>

            <p className="auth-footer-note">
              © 2026 InstaTeam. All rights reserved.
              <br />
              v1.0.0
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
